import styled from 'styled-components';
import { motion } from 'framer-motion';

const BodyWrapperStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const BodyContainerStyled = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const MainContentStyled = styled(motion.div)`
  width: 100%;
  padding: 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const MainContainerStyled = styled.div`
  width: 100%;
  z-index: 4;
  position: relative;
  height: 100%;
`;

const SelfActivationWrapperStyled = styled.div`
  background-color: #fff;
`;

export {
  BodyWrapperStyled,
  BodyContainerStyled,
  MainContentStyled,
  MainContainerStyled,
  SelfActivationWrapperStyled,
};
